import Page from 'modules/Page';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import { i18n } from 'i18n';
import * as parentConstants from '../../constants';
import useEditRheologyQueries, { EditRheologyQueries } from '../../../../shared/EditRheologyPage/useEditRheologyQueries';
import * as constants from './constants';
import { EditRheologyPageParams } from './constants';

const EditRheologyPage = lazyWithSuspense(() => import('./EditRheologyPage'));

const page: Page = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  admin: false,
  component: makePage<EditRheologyPageParams, EditRheologyQueries>({
    WrappedPage: EditRheologyPage,
    titleFn: ([rheologyQuery]) => {
      const title = rheologyQuery.data ? rheologyQuery.data.reference : '';
      return i18n._('Edit').concat(`${title}`).concat(i18n._('Rheology Data'));
    },
    parentPathTemplate: parentConstants.DETAILS_ROUTE_PATH,
    parentTitleFn: () => i18n._(parentConstants.DETAILS_TITLE),
    pageDataHook: useEditRheologyQueries,
  }),
};

export default page;
